// Single source of truth for the blog TipTap schema. Used by BlogRenderer
// (display), BlogEditor (authoring, via blog-editor-extensions.ts) and
// migration/wp-html.ts (WP HTML import); keeping them identical guarantees
// migrated JSON renders exactly like editor-authored JSON.
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import Youtube from "@tiptap/extension-youtube";
import { VideoNode } from "./video-node";

export const blogExtensions = [
  // StarterKit v3 already registers link and underline; configure them here
  // instead of adding the extensions again (duplicate names).
  StarterKit.configure({
    heading: { levels: [2, 3] },
    link: {
      // Only affects the editor; static rendering has no click handling.
      openOnClick: false,
      HTMLAttributes: {
        rel: "noopener noreferrer",
        target: "_blank",
      },
    },
  }),
  Image,
  Youtube.configure({ nocookie: true, width: 640, height: 360 }),
  VideoNode,
];
